import { Grid } from "@material-ui/core";
import ScreenTitle from "../../../components/common/ScreenTitle";
import ReglasList from "../components/ReglasList";

const CostosReglasScreen = () => {
  return (
    <Grid container spacing={2}>
      <ScreenTitle title="Reglas" />
      <ReglasList />
    </Grid>
  );
};

export default CostosReglasScreen;
